export const CUSTOMER_ROLE_ID = 4;
export const PARTNER_ROLE_ID = 8;
export const CUSTOMER_HOME_PATH = '/restaurants';

/** True when the host is the partner portal (partners.peppar.in, partners.localhost, …). */
export function isPartnersHost(hostname?: string): boolean {
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  return host.split('.')[0] === 'partners';
}

export function isCustomerRole(roleId?: number | null): boolean {
  if (roleId == null) return false;
  return Math.abs(roleId) === CUSTOMER_ROLE_ID;
}

export function isPartnerRole(roleId?: number | null): boolean {
  if (roleId == null) return false;
  return Math.abs(roleId) === PARTNER_ROLE_ID;
}

/** Paths that should resolve to the customer restaurant listing on the main domain. */
export function isCustomerDefaultPath(path: string): boolean {
  const pathname = (path || '').split('?')[0].split('#')[0] || '/';
  return pathname === '/' || pathname === '' || pathname === '/home';
}

export function partnersPortalOrigin(hostname?: string): string {
  if (hostname) {
    const host = hostname.toLowerCase();
    if (host.endsWith('.localhost') || host === 'localhost') {
      return `http://partners.localhost${typeof window !== 'undefined' && window.location.port ? `:${window.location.port}` : ''}`;
    }
    return 'https://partners.peppar.in';
  }
  if (typeof window === 'undefined') {
    return 'https://partners.peppar.in';
  }
  const host = window.location.hostname.toLowerCase();
  const port = window.location.port ? `:${window.location.port}` : '';
  if (host.endsWith('.localhost') || host === 'localhost') {
    return `${window.location.protocol}//partners.localhost${port}`;
  }
  return 'https://partners.peppar.in';
}

export function toAbsoluteUrl(path: string, hostname?: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const origin = partnersPortalOrigin(hostname);
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
}
